<div class="video-gallery">
  <div class="video-container">
    <!-- trackBy is CRITICAL for smooth animation -->
    <ng-container *ngFor="let video of currentSlideVideos; let i = index; trackBy: trackByVideoId">
      <div class="video-item"
        [ngClass]="getVideoSizeClass(i)"
        (click)="onThumbnailClick(i)">
        <div class="video-wrapper">
          <div class="video-thumbnail">
             <img [src]="video.thumbnail" [alt]="video.title" (error)="video.thumbnailError = true" />
             <div class="video-overlay"></div>
             <button class="play-button" aria-label="Play video">
               <img src="../../../assets/gallery-page/life-at-kalpita/btn.png" alt="Play button">
             </button>
          </div>
        </div>
        <div class="video-title"><span>{{ video.title }}</span></div>
      </div>
    </ng-container>
  </div>

  <div class="carousel-dots">
    <span *ngFor="let dot of [].constructor(dotCount); let di = index" class="dot"
      [class.active]="di === getActiveDot()" (click)="onDotClick(di)"></span>
  </div>

  <!-- Video Modal -->
  <div class="video-modal-overlay" *ngIf="showVideoModal" (click)="closeVideoModal()">
    <div class="video-modal-container" (click)="$event.stopPropagation()">
      <button class="modal-close-btn" (click)="closeVideoModal()" aria-label="Close video"></button>
      <div class="modal-video-wrapper">
        <iframe class="modal-video-iframe" [src]="currentModalVideo?.safeUrl" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      </div>
      <div class="modal-video-title">{{ currentModalVideo?.title }}</div>
    </div>
  </div>
</div>